jQuery(document).ready(function ($) {

    /**
     * Banner animation.
     */

    var height = $(this).scrollTop();
    var width = $(this).width();
    $(document).scroll(function () {
        height = $(this).scrollTop();
        width = $(this).width();

        if ($(".banner-block").length === 0) return;
        let top = $(window).scrollTop();
        let div = $(".banner-block").offset().top;

        if (top > div - 150) {
            $(".banner-block").addClass("animated-banner");
        }
    });

    /**
     * Mobile menu.
     */

    $('.modal-body input[type="submit"]').on("click", function () {
        setTimeout(function () {
            let error = $(".wpcf7-form-control-wrap span.wpcf7-not-valid-tip");
            error.text($("#validation_error_message").text());
            error.css("display", "block");
        }, 1100);
    });

    $("#mobile-menu").on("click", function () {
        var header = $(".header");
        header.hasClass("mobile-header")
            ? header.removeClass("mobile-header")
            : header.addClass("mobile-header");
    });

    /**
     * Faq
     */

    $(".faq-question").on("click", function () {
        let e = $(this).parent();

        if (e.hasClass("faq-open")) {
            e.removeClass("faq-open")
        } else {
            e.addClass("faq-open");

            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: e.offset().top - 100
                }, 200);
            }, 500)
        }

        $(".faq-answer").each(function () {
            if (!$(this).parent().is(e)) {
                $(this).parent().removeClass("faq-open");
            }
        });
    });

    /**
     * Lightbox for gallery images.
     */

    $(".wp-block-gallery img, .wpforms-image-choices-image img, .image-wrapper.post-wrapper img").each(function (index, value) {

        var src = $(this).attr("data-src") || $(this)[0].currentSrc || '';

        if ($(this).siblings('figcaption').text()) {
            const title = $(this).siblings('figcaption').text();
            $(this).wrap('<a href="' + src + '" data-lightbox="gallery" data-title="' + title + '" >', "</a>");
        } else {
            $(this).wrap('<a href="' + src + '" data-lightbox="gallery">', "</a>");
        }
    });

    /**
     * Version for disabled.
     */

    $("body").bind("keypress", function (e) {
        if (e.shiftKey && e.target.tagName === "BODY") {
            switch (e.which) {
                case 72: // key h
                    location.href = "/";
                    break;
                case 73: // key i
                    location.href = "/version-for-disabled-people/";
                    break;
                case 77: // key m
                    location.href = "/sitemap/";
                    break;
                case 83: // key s
                    $(".search-nav").addClass("search-open");
                    setTimeout(function () {
                        $("#search-nav").focus();
                    }, 10);
                    break;
            }
        }
    });

    $(document).on("mouseleave", ".search-open", function () {
        $(".search-nav").removeClass("search-open");
    });

    $(".contact-form").on("click", function (e) {
        e.preventDefault();

        let form = $(this).attr("id");
        let contact_modal = $(".contact-modal");
        $(".contact-modal .modal-contact-form").each(function () {
            $(this).addClass("closed");
        });

        contact_modal.find("." + form).removeClass("closed");
        contact_modal.removeClass("closed").addClass("open");
    });

    $(".modal-back, .modal-close").on("click", function () {
        $(".contact-modal").removeClass("open").addClass("closed");
    });

    $(document).ready(function () {
        let $form = $("#mc_embed_signup form");
        if ($form.length > 0) {
            $('#mc_embed_signup form input[type="submit"]').bind(
                "click",
                function (event) {
                    if (event) event.preventDefault();

                    $.ajax({
                        type: $form.attr("method"),
                        url: $form.attr("action"),
                        data: $form.serialize(),
                        cache: false,
                        jsonp: "c",
                        dataType: "jsonp",
                        contentType: "application/json; charset=utf-8",
                        error: function (err) {
                            $("#newsletter-error").remove();
                            $(".mc-field-group").append(
                                '<span id="newsletter-error">Could not connect to the registration server. Please try again later.</span>'
                            );
                        },
                        success: function (data) {
                            $("#newsletter-error").remove();
                            if (data.result != "success") {
                                let a = data.msg.split(" - ");
                                let message = data.msg;

                                if (a.length > 1) message = data.msg.split(" - ")[1];

                                if (message.includes("jau įtrauktas")) {
                                    message = "This email address has already subscribed.";
                                }

                                $(".mc-field-group").append(
                                    '<span id="newsletter-error">' + message + "</span>"
                                );
                            } else {
                                $(".mc-field-group").append(
                                    '<span id="newsletter-error">Thank You For Subscribing!</span>'
                                );
                            }
                        },
                    });
                }
            );
        }
    });
});

/**
 * Mobile menu show/hide on resize.
 */

window.addEventListener("resize", function () {
    if (window.innerWidth > 800) {
        document.querySelector(".header").classList.remove("mobile-header");
    }
});

(function () {
    /**
     * Lazy load images.
     */

    let lazy = [];

    // registerListener("load", lazyLoad);
    // registerListener("scroll", lazyLoad);
    // registerListener("resize", lazyLoad);
    // registerListener("mouseover", lazyLoad);

    function registerListener(event, func) {
        if (window.addEventListener) {
            window.addEventListener(event, func);
        } else {
            window.attachEvent("on" + event, func);
        }
    }

    let instagramSlide = document.getElementById("instagram-feed");
    if (typeof instagramSlide != "undefined" && instagramSlide != null) {
        let glide;
        let settings = {
            type: "slider",
            gap: 0,
            perView: 10,
            startAt: 0,
            bound: true,
            breakpoints: {
                2560: {perView: 7},
                1920: {perView: 7},
                1560: {perView: 6},
                1360: {perView: 5},
                1280: {perView: 4},
                800: {perView: 3},
                500: {perView: 2},
                320: {perView: 1},
            },
        };

        glide = new Glide("#instagram-feed", settings);
        glide.on("move", function (e, f) {
            resize();
        });
        glide.mount();

        resize();

        function resize() {
            let images = document.querySelectorAll(".instagram-block img");
            for (let i = 0; i < images.length; i++) {
                images[i].style.height = images[i].width + "px";
                images[i].classList.add("loaded");
            }
        }
    }

    function lazyLoad() {
        lazy = document.getElementsByClassName("lazy-image");

        for (let i = 0; i < lazy.length; i++) {
            if (isInViewport(lazy[i])) {
                if (lazy[i].getAttribute("data-src")) {
                    if (lazy[i].tagName === "IMG") {
                        lazy[i].src = lazy[i].getAttribute("data-src");
                        lazy[i].removeAttribute("data-src");
                    } else {
                        lazy[i].style["background-image"] =
                            'url("' + lazy[i].getAttribute("data-src") + '")';
                        lazy[i].removeAttribute("data-src");
                    }
                }
            }
        }

        lazy = Array.prototype.filter.call(lazy, function (l) {
            return l.getAttribute("data-src");
        });
    }

    function isInViewport(el) {
        var rect = el.getBoundingClientRect();
        return (
            rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    var x, i, j, selElmnt, a, b, c;
    x = document.getElementsByClassName("lang");

    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];

        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

        x[i].appendChild(a);

        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 0; j < selElmnt.length; j++) {
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            if (selElmnt.options[j].selected) continue;

            c.addEventListener("click", function (e) {
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;
                for (i = 0; i < s.length; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        for (k = 0; k < y.length; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                    }
                }
                h.click();
                window.location.href =
                    "http://" +
                    window.location.hostname +
                    "/" +
                    h.textContent.toLowerCase();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);

        a.addEventListener("click", function (e) {
            e.stopPropagation();
            closeAllSelect(this);

            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    }

    function closeAllSelect(elmnt) {
        var x,
            y,
            i,
            arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    document.addEventListener("click", closeAllSelect);

    setCookie("pll_language", getCookie("pll_language"));

    function setCookie(name, value) {
        expires = "; expires=" + 0;
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(";");

        for (var i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }

        return null;
    }
})();

var $navigationLinks = $(".menu a");
var $sections = $($(".programme-structure").get().reverse());

var sectionIdTonavigationLink = {};
$sections.each(function () {
    var id = $(this).attr("id");
    sectionIdTonavigationLink[id] = $(".menu a[href=\\#" + id + "]");
});

function throttle(fn, interval) {
    var lastCall, timeoutId;
    return function () {
        var now = new Date().getTime();
        if (lastCall && now < lastCall + interval) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                lastCall = now;
                fn.call();
            }, interval - (now - lastCall));
        } else {
            lastCall = now;
            fn.call();
        }
    };
}

function highlightNavigation() {
    var scrollPosition = $(window).scrollTop();

    $sections.each(function () {
        var currentSection = $(this);
        var sectionTop = currentSection.offset().top;
        if (scrollPosition + 5 >= sectionTop) {
            var id = currentSection.attr("id");
            var $navigationLink = sectionIdTonavigationLink[id];
            if (!$navigationLink.hasClass("active")) {
                $navigationLinks.removeClass("active");
                $navigationLink.addClass("active");
            }
            return false;
        }
    });
}

$(window).scroll(throttle(highlightNavigation, 100));

$('ul.sub-menu').children('.second').click(function () {
    $(this).children('.sub-menu').slideToggle('slow');
}).children('ul').find('.third').click(function (event) {
    event.stopPropagation();

    return false;
});


(function () {

    class Menu {
        constructor() {
            this.getSelectors();
            this.setEventListeners();
        }

        getSelectors() {
            this.menuItems = document.querySelectorAll('.js-menu-item .menu-item');
            this.closeButtons = document.querySelectorAll('.js-back-button');
            this.subMenus = document.querySelectorAll('.js-sub-menu');
            this.overlay = document.querySelector('#overlay');
            this.closeMenuButtons = document.querySelectorAll('.js-close-menu');
            this.sideBar = document.querySelector('#sidebar');
        }

        setEventListeners() {
            if (this.closeButtons.length > 0) {
                for (const closeButton of this.closeButtons) {
                    closeButton.addEventListener('click', (e) => {
                        this.closeMenus(e);
                    })
                }
            }

            if (this.menuItems.length > 0) {
                for (const item of this.menuItems) {
                    item.addEventListener('click', (e) => {
                        this.handleSubMenu(item, e);
                    })
                }
            }

            if (this.overlay) {
                this.overlay.addEventListener('click', (e) => {
                    this.closeMenus(e);
                    this.sideBar.classList.remove('active');
                    this.overlay.classList.remove('active');
                })
            }

            if (this.closeMenuButtons.length > 0) {
                for (const closeMenuButton of this.closeMenuButtons) {
                    closeMenuButton.addEventListener('click', (e) => {
                        this.closeMenus(e);
                        this.sideBar.classList.remove('active');
                        this.overlay.classList.remove('active');
                    })
                }
            }
        }

        closeMenus(event) {
            event.stopPropagation()

            for (const subMenu of this.subMenus) {
                if (subMenu.classList.contains('open')) {
                    subMenu.classList.remove('open');
                }
            }
        }

        handleSubMenu(item, event) {
            event.stopPropagation()

            for (const activeMenu of this.menuItems) {
                if (activeMenu.querySelector('.sub-menu')) {
                    activeMenu.querySelector('.sub-menu').classList.remove('open');
                }
            }

            if (item.querySelector('.sub-menu')) {
                item.querySelector('.sub-menu').classList.add('open');
            }
        }
    }

    new Menu()
})();


// $(document).ready(function () {

//   $('.menu-item-has-children').click(function() {
//     $(this).children('.sub-menu').addClass('open');
//   });

//   $('.menu-item-has-children .sub-menu .sub-menu-wrapper .sub-menu-items .back-button').click(function (e) {
//     $(this).parent().parent().parent().removeClass('open');
//     return false;
//   });

//   $('.menu-item-has-children .sub-menu .sub-menu-wrapper .sub-menu-items #dismiss').click(function (e) {
//     $(this).parent().parent().parent().removeClass('open');
//     return false;
//   });


//   $('#overlay').click(function (e) {
//     $('.sub-menu').removeClass('open');
//     return false;
//   });

// });

function menuExpand() {
    document.getElementById("sidebar").classList.add("active");
    document.getElementById("overlay").classList.add("active");
}

// function menuClose() {
//   document.getElementById("sidebar").classList.remove("active");
//   document.getElementById("overlay").classList.remove("active");
//   document.getElementsByClassName("sub-menu")[0].classList.remove("open");
// }

$(document).click((event) => {
    if (document.querySelector("#overlay").classList.contains("active")) {
        if (!$(event.target).closest("#sidebar").length) {
        }
    }
});


function showSearch() {
    document.getElementById("search-nav").classList.toggle("active");
    document.getElementById("mobile-search").classList.toggle("active");

    if (document.getElementById("search-open").style.display === "none") {
        document.getElementById("search-open").style.display = "block";
    } else {
        document.getElementById("search-open").style.display = "none";
    }

    if (document.getElementById("search-close").style.display === "block") {
        document.getElementById("search-close").style.display = "none";
    } else {
        document.getElementById("search-close").style.display = "block";
    }

    if (document.getElementById("search-open-mobile").style.display === "none") {
        document.getElementById("search-open-mobile").style.display = "block";
    } else {
        document.getElementById("search-open-mobile").style.display = "none";
    }

    if (document.getElementById("search-close-mobile").style.display === "block") {
        document.getElementById("search-close-mobile").style.display = "none";
    } else {
        document.getElementById("search-close-mobile").style.display = "block";
    }
}

(function () {
    const header = document.querySelector('.header');

    if (!header) return;

    let direction = 0;
    let curScroll;
    let prevDirection = 0;
    let prevScroll = window.scrollY || document.scrollTop || 0;

    const checkScroll = () => {
        curScroll = window.scrollY || document.scrollTop || 0;

        if (curScroll > prevScroll + 10) {
            direction = 2;
        } else if (curScroll < prevScroll) {
            direction = 1;
        }

        if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
        }

        prevScroll = curScroll;
    }

    const toggleHeader = (direction, curScroll) => {

        if (direction === 2 && curScroll > 40) {
            header.classList.remove('active');
            prevDirection = direction;

        } else if (direction === 1) {
            header.classList.add('active');
            prevDirection = direction;
        }
    }

    document.addEventListener('scroll', checkScroll);

    window.addEventListener('load', checkScroll);

})();

var swiper = new Swiper(".mySwiper", {
    effect: "coverflow",
    loop: true,
    centeredSlides: true,
    coverflowEffect: {
        rotate: 0,
        stretch: 3,
        depth: 150,
        modifier: 1,
        clickable: true,
    },
    pagination: {
        el: ".swiper-pagination",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        768: {
            slidesPerView: 1.8,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 1.9,
            spaceBetween: 180,
        },
    },
});

(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const alumniBlock = document.querySelector('.js-alumni-container');

        if (alumniBlock) {
            const menuItem = document.querySelectorAll('.js-alumni-menu-item');
            const alumniBlock = document.querySelectorAll('.js-alumni-block');

            gsap.to(menuItem, {
                autoAlpha: 1,
                stagger: 0.2
            })

            ScrollTrigger.batch(alumniBlock, {
                start: "200px bottom",
                end: "top top",
                onEnter: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.5}),
            })
        }
    })
})();

function openNavigationTab(event, tabName) {

    const tabContent = document.getElementsByClassName("rfs-tab-content");

    for (const content of tabContent) {
        content.style.display = "none";
    }

    const tabButtons = document.getElementsByClassName("guideline-tab");

    for (const tab of tabButtons) {
        tab.className = tab.className.replace(" active", "");
    }

    document.getElementById(tabName).style.display = "flex";
    event.currentTarget.className += " active";
};

function showRfsDocuments() {
    const rfsDocumentsButton = document.querySelector('.js-rfs-opener');
    const rfsDocumentsWrapper = document.querySelector('.js-documents');

    if (rfsDocumentsButton) {
        rfsDocumentsWrapper.classList.toggle('active');
        rfsDocumentsButton.classList.toggle('active');
    }
};


(function () {
    const contentSlider = document.querySelector('.js-content-slider');

    if (contentSlider) {
        const swiper = new Swiper(contentSlider, {
            speed: 700,
            direction: 'horizontal',
            observeParents: true,
            observeSlideChildren: true,
            grabCursor: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            preloadImages: true,
            spaceBetween: 10,
            slidesPerView: 1,
            rewind: true,
            navigation: {
                nextEl: '.js-next-btn',
                prevEl: '.js-prev-btn',
            },
            pagination: {
                el: '.js-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }
})();

(function () {
    const newsSliders = document.querySelectorAll('.js-news-slider');

    if (newsSliders.length > 0) {
        newsSliders.forEach(newsSlider => {
            const swiper = new Swiper(newsSlider, {
                speed: 700,
                direction: 'horizontal',
                observeParents: true,
                observeSlideChildren: true,
                grabCursor: true,
                preloadImages: true,
                spaceBetween: 16,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '.js-news-next-btn',
                    prevEl: '.js-news-prev-btn',
                },
            });
        })
    }

})();

(function () {
    const studiesSlider = document.querySelector('.js-studies-swiper');
    let screen = window.matchMedia('(min-width: 992px)');

    if (studiesSlider && screen.matches) {
        const swiper = new Swiper(studiesSlider, {
            speed: 700,
            direction: 'horizontal',
            observeParents: true,
            observeSlideChildren: true,
            grabCursor: true,
            preloadImages: true,
            spaceBetween: 16,
            slidesPerView: 3,
        });
    }
})();

(function () {
    const rfsSlider = document.querySelector('.js-rfs-slider');

    if (rfsSlider) {
        const swiper = new Swiper(rfsSlider, {
            speed: 700,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: true,
            // },
            direction: 'horizontal',
            observeParents: true,
            observeSlideChildren: true,
            grabCursor: true,
            preloadImages: true,
            spaceBetween: 16,
            slidesPerView: 'auto',
        });
    }
})();

// map
(function () {
    class Map {
        constructor() {
            this.getSelectors();
            this.setEventListeners();
        }

        getSelectors() {
            this.map = document.querySelector('.js-map-wrapper');
            this.mapLoader = document.querySelector('.js-loader');
            this.templateDirectoryUrl = window.location.protocol + '//' + window.location.host + '/wp-content/themes/euconexus';
            this.initMoving = true;
        }

        setEventListeners() {
            if (this.map) {
                window.addEventListener('DOMContentLoaded', () => {
                    this.ajaxCall();
                })
            }
        }

        ajaxCall() {
            jQuery.ajax({
                url: "/wp-admin/admin-ajax.php", //this is wordpress ajax file which is already avaiable in wordpress
                type: 'POST',
                data: {
                    action: 'map',
                    initMap: this.map ? this.map.dataset.id : ''
                },
                success: (response) => {
                    this.initMap(response);
                    this.mapLoader.classList.add('hide');
                },
                error: (error) => {
                    console.log(error);
                }
            })
        }

        initMap(membersData) {
            if (!membersData.data) return false;

            const members = Object.values(membersData.data);
            let screen = window.matchMedia('(max-width: 900px)');
            let isMobile = screen.matches;

            let map = $('#js-map').vectorMap({
                map: 'europe',
                // zoomMin: 1,
                focusOn: {
                    x: 0,
                    y: 0,
                    scale: 1.5,
                },
                markers: members.map(function (h) {
                    return {
                        name: h.name,
                        latLng: h.coords,
                        status: h.location,
                    }
                }),
                labels: {
                    markers: {
                        render: function (index) {
                            return isMobile ? members[index].shortcode : members[index].name;
                        },
                        offsets: function (index) {
                            var offset = members[index]['offsets'] || [0, 0];
                            return isMobile ? [offset[0] - 15, offset[1] + 20] : [offset[0] - 20, offset[1] + 22];
                        }
                    }
                },
                onMarkerClick: function (event, id) {
                    window.open(members[id].link, '_blank');
                },
                onRegionTipShow: function (e, label, code) {
                    e.preventDefault();
                },
                onMarkerOut: function (e, code) {
                    let markers = $('#js-map').vectorMap('get', 'mapObject');
                    let values = markers.series.markers[0].values;
                    values[code] = "active";
                    markers.series.markers[0].setValues(values);
                },

                onMarkerTipShow: function (e, label, code) {
                    e.preventDefault();
                },

                onViewportChange: () => {
                    this.moveLabels();
                },
                series: {
                    markers: [{
                        attribute: 'image',
                        scale: {
                            "Purple": `${this.templateDirectoryUrl}/assets/icons/marker-1.svg`,
                            "Velvet": `${this.templateDirectoryUrl}/assets/icons/marker-6.svg`,
                            "Ligthblue": `${this.templateDirectoryUrl}/assets/icons/marker-3.svg`,
                            "Cyan": `${this.templateDirectoryUrl}/assets/icons/marker-4.svg`,
                            "Green": `${this.templateDirectoryUrl}/assets/icons/marker-5.svg`,
                            "Blue": `${this.templateDirectoryUrl}/assets/icons/marker-2.svg`,
                        },
                        values: members.reduce(function (p, c, i) {
                            p[i] = c.color;

                            return p;
                        }, {}),
                    }]
                },
                zoomButtons: false,
                zoomOnScroll: false,
                panOnDrag: false,
                backgroundColor: 'rgba(174, 206, 255, 1)',
                regionStyle: {
                    initial: {
                        fill: '#F7F7F7',
                        stroke: 'rgba(174, 206, 255, 1)',
                        "stroke-width": 0.5,
                        "stroke-opacity": 1
                    },
                    hover: {
                        fill: '#FFFFFF',
                        stroke: 'rgba(174, 206, 255, 1)',
                        "fill-opacity": 0.9,
                        "stroke-width": 0.5,
                    }
                },
                regionLabelStyle: {
                    initial: {
                        'font-size': '20',
                        'width': '50px'
                    },
                },
            });

            let viewportWidth = $(window).width();
            map_response();

            $(window).resize(function () {
                viewportWidth = $(window).width();
                map_response();
            });

            this.wrapLabels();

            function map_response() {
                if (viewportWidth > 400 && viewportWidth <= 520) {
                    $('#js-map').vectorMap('get', 'mapObject').setFocus({
                        x: 0.45,
                        y: 0.65,
                        scale: 3.2,
                        animate: false
                    })
                } else if (viewportWidth <= 400) {
                    $('#js-map').vectorMap('get', 'mapObject').setFocus({
                        x: 0.48,
                        y: 0.65,
                        scale: 3.8,
                        animate: false
                    })
                } else {
                    $('#js-map').vectorMap('get', 'mapObject').setFocus({
                        zoomMin: 2.5,
                        x: 0.45,
                        y: 0.65,
                        scale: 2.5,
                        animate: false
                    })
                }
            }
        }

        wrapLabels() {
            const labels = document.querySelectorAll('text.jvectormap-element');
            let screen = window.matchMedia('(max-width: 900px)');
            let isMobile = screen.matches;

            if (labels.length > 0) {
                for (const label of labels) {
                    const ns = 'http://www.w3.org/2000/svg';

                    const newDiv = document.createElementNS(ns, 'foreignObject');
                    newDiv.setAttribute("class", "label-wrapper");
                    let x = label.getAttribute('x');
                    let y = label.getAttribute('y');

                    newDiv.setAttribute('height', 50);
                    newDiv.setAttribute('width', 100);
                    newDiv.setAttribute('x', x);
                    newDiv.setAttribute('y', isMobile ? y - 4 : y);

                    label.parentNode.insertBefore(newDiv, label);
                    newDiv.innerHTML = label.textContent;
                }
            }
        }

        moveLabels() {
            const mapLabelCoords = document.querySelectorAll('text.jvectormap-element');
            const mapLabels = document.querySelectorAll('.label-wrapper');
            let screen = window.matchMedia('(max-width: 900px)');
            let isMobile = screen.matches;

            if (mapLabels.length > 0) {
                for (const mapCoord of mapLabelCoords) {
                    for (const label of mapLabels) {
                        if (mapCoord.textContent === label.textContent) {

                            let x = mapCoord.getAttribute('x');
                            let y = mapCoord.getAttribute('y');

                            isMobile ? label.setAttribute('x', x - 10) : label.setAttribute('x', x - 10);
                            label.setAttribute('y', isMobile ? y - 4 : y);
                        }
                    }
                }
            }
        }
    }

    new Map()
})();


// tabs
(function () {
    const tabsSection = document.querySelector('.js-tabs-section');

    window.addEventListener('DOMContentLoaded', () => {

        if (tabsSection) {
            const navigationWrapper = document.querySelector('.js-navigation');
            const tabClass = tabsSection.dataset.class;
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const activeTab = urlParams.get('tab') || false;
            const scrollToTab = urlParams.get('scroll') || false;
            const elementsWithClassAndTab = document.querySelectorAll('a[href*="tab="]');
            const sections = document.querySelectorAll('.' + tabClass);

            const normalizeTitle = (title) => {
                if (!title) return '';
                const words = title.split('-');
                return words.join(' ');
            }

            const setButtons = () => {
                sections.forEach((section, index) => {
                    let className;

                    if (activeTab) {
                        const lowerActiveTab = activeTab.toLowerCase();
                        const lowerSectionId = section.id.toLowerCase();

                        className = lowerActiveTab === lowerSectionId ? 'active' : '';

                        if (lowerActiveTab !== lowerSectionId) {
                            section.classList.add('hide-section');
                        } else {
                            if (scrollToTab === 'true') {
                                setTimeout(() => {
                                    section.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                                }, 500)
                            }
                        }
                    } else {
                        className = index == 0 ? 'active' : '';

                        if (index !== 0) {
                            section.classList.add('hide-section');
                        }
                    }

                    const title = normalizeTitle(section.id);
                    const button = document.createElement('button');
                    button.className = `tab js-tab ${className}`;
                    button.setAttribute('data-name', section.id);
                    button.textContent = title;
                    navigationWrapper.appendChild(button);
                });
            }

            const addEventListeners = () => {
                const tabs = document.querySelectorAll('.js-tab');

                if (tabs) {
                    for (const tab of tabs) {
                        tab.addEventListener('click', () => {
                            tabs.forEach(activeTab => activeTab.classList.remove('active'));
                            tab.classList.add('active');

                            sections.forEach(section => {
                                if (tab.dataset.name === section.id) {
                                    sections.forEach(activeSection => activeSection.classList.add('hide-section'));
                                    section.classList.remove('hide-section');
                                }
                            });
                        });
                    }
                }
            }

            const addAnchors = () => {
                const tabs = document.querySelectorAll('.js-tab');

                if (elementsWithClassAndTab.length > 0) {
                    elementsWithClassAndTab.forEach(anchor => {
                        anchor.addEventListener('click', (e) => {
                            e.preventDefault();

                            const href = e.target.getAttribute('href');
                            const tabValue = new URL(href).searchParams.get('tab');

                            // Get the current page URL
                            const currentPageUrl = window.location.href;

                            // Check if the href contains the same URL as the current page
                            if (href.includes(currentPageUrl) && tabValue && tabs.length > 0) {
                                tabs.forEach(tab => {
                                    if (tabValue === tab.dataset.name) {
                                        tabs.forEach(activeTab => activeTab.classList.remove('active'));
                                        tab.classList.add('active');

                                        sections.forEach(section => {
                                            if (tab.dataset.name === section.id) {
                                                sections.forEach(activeSection => activeSection.classList.add('hide-section'));
                                                section.classList.remove('hide-section');
                                                section.scrollIntoView({
                                                    behavior: "smooth",
                                                    block: "start",
                                                    inline: "nearest"
                                                });
                                            }
                                        });
                                    }
                                });
                            } else {
                                window.location.href = href;
                            }
                        });
                    });
                }
            }

            setButtons();
            addEventListeners();
            addAnchors();
        }
    });
})();

// persons
(function () {
    const personBlocks = document.querySelectorAll('.js-person-block');

    if (personBlocks.length > 0) {
        window.addEventListener('load', () => {
            ScrollTrigger.batch(personBlocks, {
                start: "top center",
                end: "top bottom",
                interval: 0.1, // time window (in seconds) for batching to occur.
                batchMax: 3,
                onEnter: batch => {
                    batch.forEach((card, index) => gsap.to(card.querySelector('.js-person-block-image'), {
                        opacity: 1,
                        x: 0,
                        duration: 0.6,
                        ease: "power2.out",
                    }))
                }
            })
        })
    }

})();

// dropdowns
(function () {
    const dropDownElements = document.querySelectorAll('.js-dropdown-element');

    if (dropDownElements.length > 0) {
        for (const element of dropDownElements) {
            element.addEventListener('click', () => {
                if (element.classList.contains('active')) {
                    element.classList.remove('active');

                    if (element.nextElementSibling) {
                        element.nextElementSibling.classList.remove('neighbour');
                    }

                } else {

                    for (const activeElement of dropDownElements) {
                        activeElement.classList.remove('active');

                        if (activeElement.nextElementSibling) {
                            activeElement.nextElementSibling.classList.remove('neighbour');
                        }
                    }

                    element.classList.add('active');

                    if (element.nextElementSibling) {
                        element.nextElementSibling.classList.add('neighbour');
                    }
                }
            })

            const content = element.querySelector('.drp-dwn-content')

            content.addEventListener('click', (e) => {
                e.stopPropagation();
            })
        }
    }
})();

(function () {
    const videoContainers = document.querySelectorAll('.js-video-container');

    if (videoContainers.length > 0) {
        videoContainers.forEach(videoContainer => {
            if (videoContainer) {
                new Swiper(videoContainer, {
                    effect: "coverflow",
                    loop: false,
                    rewind: true,
                    preventClicks: true,
                    centeredSlides: true,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 3,
                        depth: 150,
                        modifier: 1,
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                        },
                        768: {
                            slidesPerView: 1.8,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 1.9,
                            spaceBetween: 180,
                        },
                    },
                });
            }
        })
    }
})();

(function () {
    const contactsCarousel = document.querySelector('.js-contacts-carousel');

    const readMoreButtons = () => {

        const slides = contactsCarousel.querySelectorAll('.js-contact-slide');

        if (slides.length > 0) {
            for (const slide of slides) {
                const text = slide.querySelector('.js-text');
                const button = slide.querySelector('.js-read-more');

                if (text && text.offsetHeight > 110) {
                    text.classList.add('add');
                } else {
                    button && button.classList.add('hide');
                }

                button && button.addEventListener('click', () => {

                    if (button.classList.contains('open')) {

                        text && text.classList.toggle('show');
                        button && button.classList.toggle('open');

                    } else {
                        for (const activeSlide of slides) {
                            const activeButton = activeSlide.querySelector('.js-read-more');
                            const activeText = activeSlide.querySelector('.js-text');

                            activeButton && activeButton.classList.remove('open');
                            activeText && activeText.classList.remove('show');
                        }

                        text && text.classList.add('show');
                        button && button.classList.add('open');
                    }
                });
            }
        }
    }

    if (contactsCarousel) {
        new Swiper(contactsCarousel, {
            direction: 'horizontal',
            // observeParents: true,
            // observeSlideChildren: true,
            grabCursor: true,
            preloadImages: true,
            spaceBetween: 16,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            rewind: true,
            navigation: {
                nextEl: '.js-next-btn',
                prevEl: '.js-prev-btn',
            },
            on: {
                afterInit: readMoreButtons()
            },
        });
    }

})();

(function () {
    const videoTestimonials = document.querySelector('.js-video-testimonials');

    if (videoTestimonials) {
        new Swiper(videoTestimonials, {
            direction: 'horizontal',
            grabCursor: true,
            spaceBetween: 16,
            rewind: true,
            navigation: {
                nextEl: '.js-next-btn',
                prevEl: '.js-prev-btn',
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                }
            }
        });
    }
})();

(function () {
    window.addEventListener('load', () => {
        const trackWrappers = document.querySelectorAll('.courses-wrapper.track');
        const trackDrpDwnBtns = document.querySelectorAll('.track-dropdown-btn');
        const enableEventListeners = () => {
            for (const btn of trackDrpDwnBtns) {
                btn.addEventListener('click', () => {
                    for (const wrapper of trackWrappers) {
                        if (btn.dataset.btn === wrapper.dataset.block) {
                            btn.classList.toggle('open');
                            wrapper.classList.toggle('hide');
                        }
                    }
                })
            }
        }

        if (trackWrappers.length > 0 && trackDrpDwnBtns.length > 0) {
            enableEventListeners();
        }
    })
})();

(function () {
    const mediaSlider = document.querySelector('.js-media-slider');

    if (mediaSlider) {
        const swiper = new Swiper(mediaSlider, {
            slidesPerView: 1,
            spaceBetween: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            direction: 'horizontal',
            grabCursor: true,
            rewind: true,
            breakpoints: {
                540: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 18,
                },
            },
        });
    }
})();

(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const textAppearBlocks = document.querySelectorAll('.js-text-appear-block');

        if (textAppearBlocks.length > 0) {

            textAppearBlocks.forEach(textAppearBlock => {
                const texts = textAppearBlock.querySelectorAll('.word');
                const duration = 1.4;

                gsap.to(texts, {
                    scrollTrigger: {
                        trigger: textAppearBlock,
                        start: "top center",
                        end: "top 30%",
                        once: true,
                    },
                    autoAlpha: 1,
                    scale: 1,
                    transformOrigin: 'center',
                    ease: "power4.out",
                    stagger: duration / texts.length,
                    duration: duration
                })
            })
        }
    })
})();

(function () {
    const mapWrapper = document.querySelector('.js-map-content-block');

    if (!mapWrapper) return;

    const map = mapWrapper.querySelector('.js-map');
    const mapData = JSON.parse(map.dataset.codes);
    const mapCountries = map.querySelectorAll('.js-country');
    const mapModals = mapWrapper.querySelectorAll('.js-map-modal');

    mapCountries.forEach(country => {
        for (const code of mapData) {
            if (code === country.dataset.code) {
                country.classList.add('enable')
            }
        }

        if (mapModals.length > 0) {
            country.addEventListener('click', () => {
                mapModals.forEach(modal => {
                    if (country.dataset.code === modal.dataset.code && modal.dataset.url) {
                        window.open(modal.dataset.url)
                    }
                })
            })

            country.addEventListener('mouseenter', (e) => {
                mapModals.forEach(modal => {
                    if (country.dataset.code === modal.dataset.code) {
                        country.classList.add('active');
                        mapCountries.forEach(activeCountry => {
                            if (country.dataset.code === activeCountry.dataset.code) activeCountry.classList.add('active')
                        });
                        modal.classList.add('active');
                        if (modal.offsetWidth < e.clientX) {
                            modal.style.transform = `translate(${e.clientX - modal.offsetWidth + 'px'}, ${e.clientY + 'px'})`
                        } else {
                            modal.style.transform = `translate(50%, ${e.clientY + 'px'})`
                        }
                    }
                })
            })

            country.addEventListener('mousemove', (e) => {
                mapModals.forEach(modal => {
                    if (country.dataset.code === modal.dataset.code) {
                        if (modal.offsetWidth < e.clientX) {
                            modal.style.transform = `translate(${e.clientX - modal.offsetWidth + 'px'}, ${e.clientY + 'px'})`
                        } else {
                            modal.style.transform = `translate(50%, ${e.clientY + 'px'})`
                        }
                    }
                })
            })

            country.addEventListener('mouseleave', () => {
                mapModals.forEach(modal => {
                    if (country.dataset.code === modal.dataset.code) {
                        modal.classList.remove('active');
                        mapCountries.forEach(activeCountry => {
                            if (country.dataset.code === activeCountry.dataset.code) activeCountry.classList.remove('active')
                        });
                    }
                })
            })
        }
    })
})();

function debounce(func, delay) {
    let timeoutId;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
            func.apply(context, args);
        }, delay);
    };
}

(function () {
    class Calls {
        constructor() {
            this.main = document.querySelector('.js-calls');

            if (!this.main) return;

            this.getSelectors();
            this.setEventListeners();
            this.initSelect();
            this.selectedTerms = [];
            this.filterData = {
                search: '',
                terms: [],
            };
        }

        getSelectors = () => {
            this.postsGrid = this.main.querySelector('.js-calls-content');
            this.loader = this.main.querySelector('.js-loader');
            this.credentialInputs = this.main.querySelectorAll('.js-calls-input');
            this.audienceSelect = this.main.querySelector('.js-audience-select');
            this.topicSelect = this.main.querySelector('.js-topic-select');
            this.loadMoreBtn = this.main.querySelector('.js-load-more');
            this.searchInput = this.main.querySelector('.js-calls-search');
            this.noPostsWrapper = this.main.querySelector('.js-no-posts');
            this.sector = '';
            this.university = '';
        }

        setEventListeners = () => {

            this.searchInput.addEventListener('input', debounce(() => {
                this.filterData.search = this.searchInput.value;
                this.ajaxCall(this.filterData, false, true);
            }, 800));

            this.credentialInputs.forEach(input => {
                input.addEventListener('change', () => {
                    this.filterData.terms = [];

                    if (this.audienceSelect && this.audienceSelect.value) {
                        this.filterData.terms.push(this.audienceSelect.value)
                    }

                    if (this.topicSelect && this.topicSelect.value) {
                        this.filterData.terms.push(this.topicSelect.value);
                    }

                    this.ajaxCall(this.filterData);
                })
            })

            this.loadMoreBtn.addEventListener('click', () => {
                this.ajaxCall(this.filterData, true);
            })

        }

        initSelect = () => {
            const selectElements = document.querySelectorAll('.js-calls-input');

            if (selectElements.length > 0) {
                for (const select of selectElements) {
                    const choices = new Choices(select, {
                        searchEnabled: true,
                        placeholder: true,
                        allowHTML: true,
                        position: 'bottom',
                        itemSelectText: '',
                        removeItemButton: true,
                        classNames: {
                            placeholder: 'choices__placeholder',
                        }
                    });
                }
            }
        }

        ajaxCall = (data, loadMore = false, search = false) => {

            const postsCount = this.main.querySelectorAll('.js-call-card').length;

            if (!data) return;

            this.loader.classList.remove('hide');

            jQuery.ajax({
                url: "/wp-admin/admin-ajax.php", //this is wordpress ajax file which is already avaiable in wordpress
                type: 'GET',
                data: {
                    action: 'calls',
                    data: {
                        terms: data.terms,
                        postsCount: postsCount,
                        searchQuery: data.search
                    },
                    loadMore: loadMore,
                    search: search
                },
                success: (response) => {
                    this.handleResponse(response, loadMore);
                },
                error: (error) => {
                    this.noPostsWrapper.classList.remove('hide');

                    console.log(error);
                }
            })
        }

        handleResponse(response, loadMore = false) {
            this.loader.classList.add('hide');

            loadMore ? this.addPosts(response.data.html) : this.replacePosts(response.data.html);

            this.handleFilterElements(response.data.count);
        }

        replacePosts(HTMLResults) {
            this.postsGrid.innerHTML = HTMLResults ? HTMLResults : ''; // filtered
        }

        addPosts(HTMLResults) {
            this.postsGrid.innerHTML += HTMLResults ? HTMLResults : ''; // load more
        }

        handleFilterElements(allPostsCount) {
            const displayedPostsCount = this.main.querySelectorAll('.js-call-card').length;

            if (displayedPostsCount > 0) {
                this.noPostsWrapper.classList.add('hide');

                if (displayedPostsCount >= allPostsCount) {
                    this.loadMoreBtn.classList.add('hide');
                } else {
                    this.loadMoreBtn.classList.remove('hide');
                }
            } else {
                this.noPostsWrapper.classList.remove('hide');
                this.loadMoreBtn.classList.add('hide');
            }
        }
    }

    new Calls();
})();

(function () {
    class Credentials {
        constructor() {
            this.main = document.querySelector('.js-micro-credentials');

            if (!this.main) return;

            this.getSelectors();
            this.setEventListeners();
            this.initSelect();
            this.selectedTerms = [];
            this.filterData = {
                search: '',
                terms: [],
            };
        }

        getSelectors = () => {
            this.postsGrid = this.main.querySelector('.js-credentials-content');
            this.loader = this.main.querySelector('.js-loader');
            this.credentialInputs = this.main.querySelectorAll('.js-credential-input');
            this.sectorSelect = this.main.querySelector('.js-sector-select');
            this.universitySelect = this.main.querySelector('.js-university-select');
            this.thematicAreaSelect = this.main.querySelector('.js-thematic-area-select');
            this.tagSelect = this.main.querySelector('.js-credential-tag-select');
            this.filterCheckBoxes = this.main.querySelectorAll('.js-checkbox');
            this.loadMoreBtn = this.main.querySelector('.js-load-more');
            this.searchInput = this.main.querySelector('.js-credential-search');
            this.noPostsWrapper = this.main.querySelector('.js-no-posts');
            this.sector = '';
            this.university = '';
        }

        setEventListeners = () => {

            window.addEventListener('load', () => {
                this.filterCheckBoxes.forEach(checkbox => {
                    if (checkbox.checked) {
                        this.filterData.terms.push(checkbox.value);
                    }
                })
            })

            this.searchInput.addEventListener('input', debounce(() => {
                this.filterData.search = this.searchInput.value;
                this.ajaxCall(this.filterData, false, true);
            }, 800));

            this.credentialInputs.forEach(input => {
                input.addEventListener('change', () => {
                    this.filterData.terms = [];

                    this.filterCheckBoxes.forEach(checkbox => {
                        if (checkbox.checked) {
                            this.filterData.terms.push(checkbox.value);
                        }
                    })

                    if (this.universitySelect && this.universitySelect.value) {
                        this.filterData.terms.push(this.universitySelect.value)
                    }

                    if (this.sectorSelect && this.sectorSelect.value) {
                        this.filterData.terms.push(this.sectorSelect.value);
                    }

                    if (this.tagSelect && this.tagSelect.value) {
                        this.filterData.terms.push(this.tagSelect.value);
                    }

                    if (this.thematicAreaSelect) {
                        Array.from(this.thematicAreaSelect.selectedOptions).map(option => option.value).forEach(opt => {
                            this.filterData.terms.push(opt);
                        })
                    }

                    this.ajaxCall(this.filterData);
                })
            })

            this.loadMoreBtn.addEventListener('click', () => {
                this.ajaxCall(this.filterData, true);
            })

        }

        initSelect = () => {
            const selectElements = document.querySelectorAll('.credentials-select');

            if (selectElements.length > 0) {
                for (const select of selectElements) {
                    const choices = new Choices(select, {
                        searchEnabled: true,
                        placeholder: true,
                        allowHTML: true,
                        position: 'bottom',
                        itemSelectText: '',
                        removeItemButton: true,
                        classNames: {
                            placeholder: 'choices__placeholder',
                        }
                    });
                }
            }
        }

        ajaxCall = (data, loadMore = false, search = false) => {

            const postsCount = this.main.querySelectorAll('.js-credential-card').length;

            if (!data) return;

            this.loader.classList.remove('hide');

            jQuery.ajax({
                url: "/wp-admin/admin-ajax.php", //this is wordpress ajax file which is already avaiable in wordpress
                type: 'GET',
                data: {
                    action: 'credentials',
                    data: {
                        terms: data.terms,
                        postsCount: postsCount,
                        searchQuery: data.search
                    },
                    loadMore: loadMore,
                    search: search
                },
                success: (response) => {
                    this.handleResponse(response, loadMore);
                },
                error: (error) => {
                    this.noPostsWrapper.classList.remove('hide');

                    console.log(error);
                }
            })
        }

        handleResponse(response, loadMore = false) {
            this.loader.classList.add('hide');

            loadMore ? this.addPosts(response.data.html) : this.replacePosts(response.data.html);

            this.handleFilterElements(response.data.count);
        }

        replacePosts(HTMLResults) {
            this.postsGrid.innerHTML = HTMLResults ? HTMLResults : ''; // filtered
        }

        addPosts(HTMLResults) {
            this.postsGrid.innerHTML += HTMLResults ? HTMLResults : ''; // load more
        }

        handleFilterElements(allPostsCount) {
            const displayedPostsCount = this.main.querySelectorAll('.js-credential-card').length;

            if (displayedPostsCount > 0) {
                this.noPostsWrapper.classList.add('hide');

                if (displayedPostsCount >= allPostsCount) {
                    this.loadMoreBtn.classList.add('hide');
                } else {
                    this.loadMoreBtn.classList.remove('hide');
                }
            } else {
                this.noPostsWrapper.classList.remove('hide');
                this.loadMoreBtn.classList.add('hide');
            }
        }
    }

    new Credentials();
})();

(function () {
    const yElements = document.querySelectorAll('[data-appear="y"]');
    const xElements = document.querySelectorAll('[data-appear="x"]');

    window.addEventListener('DOMContentLoaded', () => {
        if (yElements.length > 0) {
            ScrollTrigger.batch(yElements, {
                start: 'top 80%',
                onEnter: batch => {
                    batch.forEach((card, index) => gsap.to(card, {
                        opacity: 1,
                        y: 0,
                        duration: 0.75,
                        scale: 1,
                        ease: 'Power1.easeOut',
                        stagger: 0.4,
                        delay: index * 0.3
                    }))
                },
                once: true
            });
        }

        if (xElements.length > 0) {
            ScrollTrigger.batch(xElements, {
                start: 'top 80%',
                onEnter: batch => {
                    batch.forEach((card, index) => gsap.to(card, {
                        opacity: 1,
                        x: 0,
                        duration: 0.75,
                        scale: 1,
                        ease: 'Power1.easeOut',
                        stagger: 0.4,
                        delay: index * 0.3
                    }))
                },
                once: true
            });
        }
    })

})();

(function () {

    const detailParentBtns = document.querySelectorAll('.js-parent-detail-btn');

    if (detailParentBtns.length > 0) {
        detailParentBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const key = btn.dataset.key;

                const childElement = document.querySelector(`div[data-detail='${key}']`);

                if (childElement) {

                    if (btn.classList.contains('active')) {
                        childElement.classList.remove('active');
                        btn.classList.remove('active');
                    } else {
                        childElement.classList.add('active');
                        btn.classList.add('active');
                    }
                }
            })
        })
    }

})();

class AnchorMenu {
    constructor() {
        this.getSelectors();
        this.setHeadings()
            .then(() => {
                this.initScrollNavigation();
            });
    }

    getSelectors() {
        this.headings = document.querySelectorAll('.js-post-content h2, .js-post-content h3, .js-post-content h4, .js-post-content h5, .js-post-content h6');
        this.navigationBlock = document.querySelector('.js-nav-sidebar-content');
    }

    async setHeadings() {
        if (this.headings.length > 0) {
            this.headings.forEach((heading) => {
                const id =
                    heading.getAttribute('id') ||
                    heading.innerText
                        .toLowerCase()
                        .replace(/[`~!@#$%^&*()_|+\-=;:'",.<>\{\}\[\]\\\/]/gi, '')
                        .replace(/ +/g, '-')

                heading.setAttribute('id', id);

                // create anchor element of each heading;
                const anchorLink = document.createElement('a');
                anchorLink.className = 'anchor-link js-anchor-link';
                anchorLink.setAttribute('data-href', id);
                anchorLink.href = '#' + id;

                anchorLink.innerText = heading.textContent;

                // add anchors to navigation menu

                if (anchorLink.innerText === "") return false;

                this.navigationBlock.appendChild(anchorLink);
            })
        }
    }

    initScrollNavigation() {
        const anchors = document.querySelectorAll('.js-anchor-link');

        if (anchors.length > 0 && this.headings.length > 0) {
            window.addEventListener('scroll', () => {
                let closestHeading = null;
                let closestAnchor = null;
                let minDistance = Infinity;

                // Find the closest heading to the top of the viewport
                this.headings.forEach((heading) => {
                    const distance = Math.abs(heading.getBoundingClientRect().top);
                    if (distance < minDistance) {
                        minDistance = distance;
                        closestHeading = heading;
                    }
                });

                // Find the corresponding anchor for the closest heading
                anchors.forEach((anchor) => {
                    if (closestHeading.id === anchor.dataset.href) {
                        closestAnchor = anchor;
                    }
                });

                // Add "active" class to the closest anchor if within threshold
                if (minDistance < 100) { // Adjust threshold as needed
                    anchors.forEach((anchor) => {
                        if (anchor === closestAnchor) {
                            anchor.classList.add('active');
                        } else {
                            anchor.classList.remove('active');
                        }
                    });
                }
            });
        }
    }

}

(function () {
    const navSideBar = document.querySelector('.js-nav-sidebar-content');
    const wysivygContent = document.querySelector('.js-post-content');

    if (navSideBar && wysivygContent) {
        new AnchorMenu();
    }
})();

(function () {
    const formModal = document.querySelector('.js-contact-form-modal');
    const contactButtons = document.querySelectorAll('.js-contact-btn');

    if (contactButtons.length > 0 && formModal) {
        contactButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const selectedUniversity = btn.dataset.university ?? '';

                const choicesInner = formModal.querySelector('.choices__inner');
                if (choicesInner) {
                    choicesInner.click();
                }

                setTimeout(function () {

                    const dropdownItems = formModal.querySelectorAll(
                        '.choices__list--dropdown .choices__item.choices__item--choice'
                    );

                    dropdownItems.forEach(function (item) {
                        if (item.getAttribute('data-value') === selectedUniversity) {
                            item.dispatchEvent(new MouseEvent('mousedown', {bubbles: true, cancelable: true}));
                            item.dispatchEvent(new MouseEvent('mouseup', {bubbles: true, cancelable: true}));
                            item.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true}));
                        }
                    });
                }, 100);

                formModal.classList.add('active');
            })
        })

        formModal.addEventListener('click', (e) => {
            if (e.target === formModal && formModal.classList.contains('active')) {
                formModal.classList.remove('active');
            }
        })
    }

})();